import React, {useRef, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Animation
import styled from 'styled-components';
import {motion} from 'framer-motion';
import ProductsReveal from './ProductsReveal';

import productbg from '../img/products/pexels-n-voitkevich-8467963.jpg'

import inoalogo from '../img/products/inoa/coral_springs_salon_products_inoa-300x158.png'
import inoa1 from '../img/products/inoa/packshot-inoa-1.webp'

import dialightlogo from '../img/products/dialight/Dialight-Logo.wine.png'
import dialight1 from '../img/products/dialight/1.png'

import diarichesselogo from '../img/products/diarichesse/product_dia-richesse.png'
import diarichesse1 from '../img/products/diarichesse/2925_ddebfb78.256x256.png'

import majirellogo from '../img/products/majirel/coral_springs_salon_products_majirel.png'
import majirel1 from '../img/products/majirel/majirel1.png'

import igoralogo from '../img/products/igoraroyal/igoralogo.svg'
import igora1 from '../img/products/igoraroyal/Igora-Royal-Tube-and-Box.webp'

gsap.registerPlugin(ScrollTrigger);

const ProductsSection = () => {
    const boxRef = useRef();
    const location = useLocation();
    useEffect(() => {
        gsap.to(boxRef.current, {
            scrollTrigger: {
                trigger: boxRef.current,
                start: "0%",
                end: "100%",
                pin: true,
                pinSpacing: false,
            }
        });
        // Cleanup on unmount
        return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }, [location.pathname]);

    return(
        <motion.section>
                    <TxtPresentation ref={boxRef}>
                        <div className="txt">
                            <h5>Nous travaillons avec les marques <em>L'Oréal&reg;</em> et <em>Schwarzkopf&reg;</em> pour votre plus grand plaisir et confort.
                            <br /><br />
                            Voici nos produits phares, sélectionnés pour répondre à vos besoins. 
                            <br /><br />
                            Prenez conseil auprès de nos coiffeurs pour vous guider sur les produits qui vous correspondront le mieux.
                            </h5>
                            <br /><br />
                            <p><i>Les noms et logos des marques mentionnés sont des marques déposées de leurs propriétaires respectifs. Leur utilisation ici n’implique aucune affiliation ou approbation officielle</i></p>
                        </div>
                        <div className="bg">
                            <span className='blur-filter'></span>
                            <img className="bg-img "src={productbg} alt="" />
                        </div>
                    </TxtPresentation>
                    <ProductsPresentation>
                        <ProductsReveal
                            className="brand"
                            brand="inoa"
                            logo={inoalogo}
                            waveColor="green"
                            baseBG="black"
                            gradientBG="linear-gradient(45deg,rgba(0, 0, 0, 1) 0%, rgba(28, 38, 32, 1) 66%, rgba(87, 199, 133, 1) 100%)"
                            slide="left">

                            <div className="txt">
                                <p>Une coloration révolutionnaire à base d'huile, sans ammoniaque.</p>
                            </div>
                            <div className="product-img">
                                <img src={inoa1} alt="" />
                            </div>
                        </ProductsReveal>

                        
                        <ProductsReveal
                            className="brand"
                            brand="majirel"
                            logo={majirellogo}
                            waveColor="rgb(134, 158, 180)"
                            baseBG="black"
                            gradientBG="linear-gradient(214deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 66%, rgba(178, 219, 212, 1) 100%)"
                            slide="right">

                            <div className="txt">
                                <p>Pour une couleur riche et profonde, et un résultat profondément soin.</p>
                            </div>
                            <div className="product-img">
                                <img src={majirel1} alt="" />
                            </div>
                        </ProductsReveal>

                        <ProductsReveal
                            className="brand"
                            brand="diarichesse"
                            logo={diarichesselogo}
                            waveColor="rgb(144, 16, 16)"
                            baseBG="rgba(230, 230, 230, 1)"
                            gradientBG="linear-gradient(135deg,rgba(230, 230, 230, 1) 4%, rgba(161, 161, 161, 1) 67%, rgba(227, 2, 70, 1) 91%)"
                            slide="left">

                            <div className="txt">
                                <p>Pensé pour cheveux naturels, idéal pour une première coloration.</p>
                            </div>
                            <div className="product-img">
                                <img src={diarichesse1} alt="" />
                            </div>
                        </ProductsReveal>

                        <ProductsReveal
                            className="brand"
                            brand="dialight"
                            logo={dialightlogo}
                            waveColor="rgb(166, 168, 65)"
                            baseBG="#e2e2e2"
                            gradientBG="linear-gradient(135deg,rgba(214, 224, 146, 1) 15%, rgba(230, 230, 230, 1) 46%, rgba(222, 222, 222, 1) 93%)"
                            slide="right">

                            <div className="txt">
                                <p>Une coloration ton sur ton épatante, pour apporter des reflets brillants et lumineux à vos cheveux.</p>
                            </div>
                            <div className="product-img">
                                <img src={dialight1} alt="" />
                            </div>
                        </ProductsReveal>

                        <ProductsReveal
                            className="brand"
                            brand="igora-royal"
                            logo={igoralogo}
                            waveColor={"rgb(90, 11, 11)"}
                            baseBG="#ae1e1e"
                            gradientBG="#ae1e1e"
                            slide="left">
                            <div className="txt">
                                <p>Des performances couleurs puissantes pour des résultats fidèles aux mèches du nuancier.</p>
                            </div>
                            <div className="product-img">
                                <img src={igora1} alt="" />
                            </div>
                        </ProductsReveal>
                    </ProductsPresentation>

        </motion.section>
    )
}

const TxtPresentation = styled(motion.div)`
    min-height: 85vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .txt{
        padding: 0rem 10rem;
        z-index: 5;
        color: white;
    }
    .bg{
        width: 100%;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
    }
    .blur-filter{
        position: absolute;
        top: 0%;left: 0;right: 0; bottom: 8%;
        background: rgba(0, 0, 0, .3);
        backdrop-filter: blur(5px);
        pointer-events: none;
        z-index: 1;
    }
    .bg img{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;
    }
    p{
        font-size: 1.2rem;
    }

    @media (max-width: 768px){
        .txt{
            padding: 3rem 3rem;
        }
        .blur-filter{
            bottom: 0%;
        }
    }
`

const ProductsPresentation = styled(motion.div)`
    display: flex;
    flex-direction: row;

    .logo{
        padding: 0 4rem;
        z-index: 3;
        height: 20%;
        img{
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
    .txt{
        padding: 0 4rem;
        position: relative;
        color: white;
        font-weight: 700;
        z-index: 3;
    }
    p{
        font-size: 1.7rem;
    }
    .product-img{
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        height: 30rem;
        z-index: 3;
        img{
            transform: rotate(-.25turn);
            max-height: 20rem;
            object-fit: contain;
        }
    }

    .diarichesse, .dialight{
        p{
            color: #202020;
        }
    }

    @media (max-width: 768px){
        flex-direction: column;
    }
`

export default ProductsSection;